export const WORKS = [
  {
    id: "heart",
    title: "Heart & Butterflies",
    subtitle: "裂心与蝴蝶",
    desc: "裂纹从纸面长出，黑色心脏被红线牵引，蝶群追逐指尖留下的脉冲。",
    renderer: "Canvas 2D · 粒子 / 贝塞尔",
    tone: "chalk",
  },
  {
    id: "yanfan",
    title: "Yanfan",
    subtitle: "燕返",
    desc: "文字从纸上松脱为燕，围绕游动的红鲤盘旋，停下后再次归位成书。",
    renderer: "SVG · WAAPI",
    tone: "paper",
  },
  {
    id: "puppet",
    title: "Marionette",
    subtitle: "提线木偶",
    desc: "指针成为操纵横杆，约束、关节和重力把一组线段唤醒成会摇摆的木偶。",
    renderer: "Canvas 2D · Verlet",
    tone: "stage",
  },
  {
    id: "typing",
    title: "Typing Bird",
    subtitle: "打字机 × 飞鸟",
    desc: "每次击键放飞一只字母燕，红线把它牵回纸面；键盘输入会真的进入画面。",
    renderer: "DOM · SVG · WAAPI",
    tone: "paper",
  },
  {
    id: "control",
    title: "Control",
    subtitle: "五线谱 × 飞鸟",
    desc: "音符被指尖惊起，在飞鸟和谱面状态之间连续变形；安静后重新落回旋律。",
    renderer: "Canvas 2D · 状态形变",
    tone: "score",
  },
  {
    id: "sparks",
    title: "Sparks",
    subtitle: "星火星座",
    desc: "原生 GPU 点精灵跟随指尖聚散成座；WebGL 不可用时自动切换 Canvas。",
    renderer: "WebGL · Canvas fallback",
    tone: "night",
  },
  {
    id: "rain",
    title: "Rain Window",
    subtitle: "雨窗",
    desc: "CSS 景深、SVG 湍流和 DOM 水滴叠成一扇夜窗，擦拭会短暂显露楼群暖光。",
    renderer: "CSS · SVG Filter · DOM",
    tone: "rain",
  },
  {
    id: "curtain",
    title: "Curtain",
    subtitle: "晨光珠帘",
    desc: "一张弹簧网格模拟珠帘，风场与指针碰撞沿整张帘幕传播。",
    renderer: "Canvas 2D · Spring Grid",
    tone: "sun",
  },
];

export const DEFAULT_SETTINGS = {
  speed: 1,
  density: 1,
  quality: "auto",
  trails: true,
  seed: 202607,
};
